import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { fmt, computePL } from '../utils';
import NewDealModal from '../components/NewDealModal';

const STATUS_CLASS = {
  'Pre-Deal': 'status-pre-deal',
  'Purchased': 'status-purchased',
  'On Market': 'status-on-market',
  'Under Contract': 'status-under-contract',
  'Sold': 'status-sold',
};

export default function DealsListPage() {
  const [deals, setDeals] = useState([]);
  const [showNew, setShowNew] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { api.getDeals().then(setDeals); }, []);

  const handleCreated = (id) => navigate(`/deals/${id}`);

  return (
    <>
      <header className="app-header">
        <img src="/logo-white.png" alt="My Fair Market Offer" style={{height:36,width:'auto'}} />
        <div className="logo-divider" />
        <span style={{color:'rgba(255,255,255,0.75)',fontSize:13,fontWeight:500,letterSpacing:'0.03em'}}>
          Rehab Estimator
        </span>
      </header>

      <div className="page">
        <div className="page-header">
          <h1>Deals</h1>
          <button className="btn-primary" onClick={() => setShowNew(true)}>+ New Deal</button>
        </div>

        {deals.length === 0 && (
          <div className="empty-state">
            <div className="icon">🏚️</div>
            <div>No deals yet. Create your first one.</div>
          </div>
        )}

        <div className="deals-grid">
          {deals.map(deal => {
            const pl = computePL({ ...deal, frontend_costs: [], backend_costs: [], holding_costs: [] });
            return (
              <div key={deal.id} className="card deal-card" onClick={() => navigate(`/deals/${deal.id}`)}>
                <div className="deal-address">{deal.address}</div>
                <span className={`deal-status ${STATUS_CLASS[deal.status] || ''}`}>{deal.status}</span>
                <div className="deal-numbers">
                  <div className="kv"><div className="k">ARV</div><div className="v money">{fmt(deal.arv)}</div></div>
                  <div className="kv"><div className="k">Purchase</div><div className="v money">{fmt(deal.purchase_price)}</div></div>
                  <div className="kv"><div className="k">MAO</div><div className="v money">{fmt(pl.mao)}</div></div>
                </div>
              </div>
            );
          })}

          <div className="card new-deal-card" onClick={() => setShowNew(true)}>
            <span style={{fontSize:24}}>＋</span> New Deal
          </div>
        </div>
      </div>

      {showNew && (
        <NewDealModal onClose={() => setShowNew(false)} onCreated={handleCreated} />
      )}
    </>
  );
}
